// React imports
import { useEffect, useRef, useState } from "react";

// 3rd party components imports
// ar-todo:  typing issues
import { SWMIcon } from "react-swm-icon-pack";
import clsx from "clsx";

// Project components

// Hooks, configs and utilities imports

// Type imports

// Local and assets imports
import "./base-icon.style.scss";

export const BaseIcon = ({ className, parentStyle, color, name, set, size, filled, strokeWidth }) => {
	return (
		<span
			className={clsx("base-icon", {
				[className ?? ""]: className,
				filled: filled,
			})}
			style={{ ...parentStyle, color: color }}
		>
			<SWMIcon
				name={name}
				set={set ?? "curved"}
				style={{ fill: "currentColor" }}
				strokeWidth={strokeWidth ?? 1.5}
				size={size ?? "24"}
			/>
		</span>
	);
};
